import { render } from "./AttributeGroup.vue?vue&type=template&id=904b8bf6"
import script from "./AttributeGroup.vue?vue&type=script&lang=js"
export * from "./AttributeGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__